import { ReactComponent as DownloadPackage } from "@/assets/svgs/download-large.svg";
import { assetUrl } from '@/utils/asset-url';
import iconBuilding from '@/assets/svgs/icon-building.svg';
import { ReactComponent as DataElementIconSuccess } from '@/assets/svgs/icon-data-element-success.svg';
import MultiClamp from 'react-multi-clamp';
import packageUserType from '@/constants/package-user-type/index';
import { useNavigate } from '@/lib/router-dom/index';
import { useParams } from '@/lib/router-dom/index.js';
import PropTypes from 'prop-types'

const ReceivedDataElementCard2 = ({
	isPackageDownloadable,
	dataElement,
	behalfPanel,
	handleShowDownloadAllModal,
	updateIsNew,
	currentPackage,
	currentFolder
}) => {

	const { eclipId } = useParams();
	const { goTo } = useNavigate();

	/*=================================================
		Organisation Avatar
	/================================================*/
	function organisationAvatar(organisation) {
		if ((Array.isArray(organisation) && organisation.length === 1) && ((organisation[0]?.iconUrl !== "") && (organisation[0]?.iconUrl !== "undefined"))) {
			return organisation[0]?.iconUrl
		}

		return iconBuilding
	}

	return (
		<div className='package-data-received-card'>
			<div className='package-data-received-card__header'>
				<div className="share-data-card__header__left">
					<DataElementIconSuccess />
				</div>

				<div className='share-data-card__header__download veridapt-data--cursor'>
					{dataElement.isNew && <span className="package-received-data-card__new-tag" data-testid="new-tag">New</span>}

					{/* pending updated condition to show download */}
					{isPackageDownloadable && (
						<span onClick={handleShowDownloadAllModal} onKeyDown={handleShowDownloadAllModal} data-testid="download-btn" role="none">
							<DownloadPackage />
						</span>
					)}
				</div>
			</div>

			<div className='package-data-received-card__data-element-name'><MultiClamp clamp={2}>{dataElement?.name}</MultiClamp></div>

			<div className='package-data-received-card__participants'>
				<div className='share-data-card__heading share-data-card__content--margin-bottom'>Participants</div>
				<div className='share-data-card__participants'>
					<div className='share-data-card__participants__icon'>
						{dataElement?.userType === packageUserType.consumer && behalfPanel && (
							<div className="avatar" style={{ backgroundImage: `url(${organisationAvatar(dataElement.providerDetail)})` }}></div>
						)}
						{dataElement?.userType === packageUserType.consumer && !behalfPanel && (
							<div className="avatar" style={{ backgroundImage: `url(${organisationAvatar(dataElement.contributorDetail)})` }}></div>
						)}
						{dataElement?.userType !== packageUserType.consumer && (
							<div className="avatar" style={{ backgroundImage: `url(${organisationAvatar(dataElement.consumerDetail)})` }}></div>
						)}
					</div>
					<div className='share-data-card__participants__right'>
						<div className='share-data-card__participants-name'>
							{dataElement?.userType === packageUserType.consumer && behalfPanel && 'Provider'}
							{dataElement?.userType === packageUserType.consumer && !behalfPanel && 'Contributor'}
							{dataElement?.userType !== packageUserType.consumer && 'Recipient'}
						</div>
						<div className='share-data-card__name'>
							{dataElement?.userType === packageUserType.consumer && behalfPanel && dataElement.providerDetail[0]?.name}
							{dataElement?.userType === packageUserType.consumer && !behalfPanel && dataElement.contributorDetail[0]?.name}
							{dataElement?.userType !== packageUserType.consumer && dataElement.consumerDetail[0]?.name}
						</div>
					</div>
				</div>

				{behalfPanel && (
					<div className='share-data-card__participants'>
						<div className='share-data-card__participants__icon'>
							{dataElement?.userType === packageUserType.contributor && (
								<div className="avatar" style={{ backgroundImage: `url(${organisationAvatar(dataElement?.providerDetail)})` }}></div>
							)}
							{dataElement?.userType !== packageUserType.contributor && (
								<div className="avatar" style={{ backgroundImage: `url(${organisationAvatar(dataElement?.contributorDetail)})` }}></div>
							)}
						</div>
						<div className='share-data-card__participants__right'>
							<div className='share-data-card__participants-name'>
								{dataElement?.userType === packageUserType.contributor && "Provider"}
								{dataElement?.userType !== packageUserType.contributor && "Provide on behalf of"}
							</div>

							<div className='share-data-card__name'>
								{dataElement?.userType === packageUserType.contributor && dataElement.providerDetail[0]?.name}
								{dataElement?.userType !== packageUserType.contributor && dataElement.contributorDetail[0]?.name}
							</div>
						</div>
					</div>
				)}
			</div>

			<div className='package-data-received-card__data-element-payload' >
				<a className='package-data-received-card__payload-link'
					onClick={() => {
						goTo(
							`/package/data-element/${eclipId}/${dataElement?.dataElementId}`,
							{
								dataElementName: dataElement?.name,
								currentPackage: currentPackage,
								currentFolder: currentFolder,
							}
						)
						updateIsNew()
					}}
					onKeyDown={() => {
						goTo(
							`/package/data-element/${eclipId}/${dataElement?.dataElementId}`,
							{
								dataElementName: dataElement?.name,
								packageName: currentPackage,
								currentFolder: currentFolder,
							}
						)
						updateIsNew()
					}}
					role="link" data-testid="view-data-element-link">
					{`View Data Elements (${dataElement?.dataElementCount || 1})`}
				</a>
			</div>
		</div>

	)
}


ReceivedDataElementCard2.propTypes = {
	dataElement: PropTypes.shape({
		userType: PropTypes.string,
		providerDetail: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
			})
		),
		consumerDetail: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
			})
		),
		contributorDetail: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string,
			})
		),
		dataElementId: PropTypes.string,
		name: PropTypes.string,
		dataElementCount: PropTypes.number,
	}),
	isPackageDownloadable: PropTypes.bool,
	behalfPanel: PropTypes.any,
	handleShowDownloadAllModal : PropTypes.any,
	updateIsNew: PropTypes.func,
	currentPackage:PropTypes.shape({
		name: PropTypes.string,
	}),
	currentFolder: PropTypes.any
};

export default ReceivedDataElementCard2
